import { space, width } from 'styled-system'
import styled from '@emotion/styled'

export default styled.div`
	${width}
	${space}
	padding: 20px;
`
